import { IconButton, TextField } from '@material-ui/core'
import React from 'react'
import { useForm } from '../../hooks/useForm'
import DeleteIcon from '@material-ui/icons/Delete';

const CollabTextField = ( {index, handleCollabInput, handleDeleteCollab, initialValue} ) => {

    const [state, handleInputChange, reset] = useForm(initialValue);

    const {
        name,
        link
    } = state;

    const handleOnClick = () => {
        handleDeleteCollab(state);
        reset();
    }

    return (
        <div className="d-flex border rounded mb-2">
            <TextField
                autoComplete="off"
                style={{width:'20%'}}
                label="Name"
                name="name"
                value={name}
                onChange={handleInputChange}
                onBlur={()=>{
                    handleCollabInput(index,state);
                }}
            />
            <TextField
                autoComplete="off"
                className="ms-4 flex-grow-1"
                label="Link"
                name="link"
                value={link}
                onChange={handleInputChange}
                onBlur={()=>{
                    handleCollabInput(index,state);
                }}
            />
            <IconButton
                onClick={handleOnClick}
            >
                <DeleteIcon />
            </IconButton>

        </div>
    )
}

export default CollabTextField;